
export { HorizontalProductCardSkeleton } from "/codebuild/output/src4122767702/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src4122767702/src/packages/shared-components/src/components/ProductCard/index.ts"